import * as yup from 'yup';
import { fieldValidationMessages } from 'app/constants';
import { PasswordPolicy } from 'types/auth';

export const passwordPolicyDefaults: PasswordPolicy = {
  maximumLength: 99,
  minimumLength: 6,
  requireUppercase: false,
  requireLowercase: false,
  requireNumbers: false,
  notSameAsCurrent: false,
  requireSpecialCharacters: false,
  pattern: '.{6}',
};

export const auddlySignUpValidationSchema = ({
  minimumLength,
  maximumLength,
  pattern,
}: PasswordPolicy = passwordPolicyDefaults) =>
  yup.object().shape({
    email: yup
      .string()
      .email(fieldValidationMessages.EMAIL)
      .required(fieldValidationMessages.REQUIRED)
      .max(128, fieldValidationMessages.MAX_CHAR(128)),
    code: yup.string().required(fieldValidationMessages.REQUIRED).length(6),
    password: yup
      .string()
      .required(fieldValidationMessages.REQUIRED_PASSWORD)
      .min(minimumLength, fieldValidationMessages.MIN_PASSWORD)
      .max(maximumLength, fieldValidationMessages.MAX_CHAR(maximumLength))
      .matches(new RegExp(pattern), fieldValidationMessages.WEAK_PASSWORD),
    passwordRepeat: yup
      .string()
      .required(fieldValidationMessages.REQUIRED_PASSWORD)
      .min(minimumLength, fieldValidationMessages.MIN_PASSWORD)
      .max(maximumLength, fieldValidationMessages.MAX_CHAR(maximumLength))
      .oneOf(
        [yup.ref('password'), null],
        "Those passwords didn't match, try again"
      ),
    city: yup
      .string()
      .required(fieldValidationMessages.REQUIRED)
      .max(100, fieldValidationMessages.MAX_CHAR(100))
      .trim(),
    country: yup.object().required(fieldValidationMessages.REQUIRED).nullable(),
  });

export const linkStyle = {
  paddingLeft: 1,
  fontWeight: 700,
  color: 'textBase',
  fontSize: 'sm',
  textDecorationColor: 'rgba(9, 11, 13, 0.4)',
  textDecoration: 'underline',
  _hover: {
    textDecorationColor: 'inherit',
  },
};
